module.exports = __webpack_public_path__ + "static/media/secure.97c56852.svg";